import { render, staticRenderFns } from "./DetailMap.vue?vue&type=template&id=22ec3c8f&scoped=true&"
import script from "./DetailMap.vue?vue&type=script&lang=js&"
export * from "./DetailMap.vue?vue&type=script&lang=js&"
import style0 from "./DetailMap.vue?vue&type=style&index=0&id=22ec3c8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec3c8f",
  null
  
)

export default component.exports